import { render, staticRenderFns } from "./CompanyWallet.vue?vue&type=template&id=4afec532&scoped=true&"
import script from "./CompanyWallet.vue?vue&type=script&lang=ts&"
export * from "./CompanyWallet.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyWallet.vue?vue&type=style&index=0&id=4afec532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afec532",
  null
  
)

export default component.exports